export type Teacher = {
    id: string;
};

/*
// Moved to the bottom for reasons
export type Teachers = {
    [key: string]: Teacher;
};
*/
export const teachers = {
    Adams_Jennifer_N: { id: '8BB5913B-8501-4333-B5F3-3948508F47CA' },
    Ainslie_John_R: { id: '189C95B7-E411-4998-8B75-999707DBF85C' },
    Allen_David_M: { id: '1522F63C-385F-4A8F-B89D-3E6F46012FE3' },
    Anderson_Derek_A: { id: '2082227C-4340-4A77-9BFD-2A91DE42E5F4' },
    Angotti_Rachel_A: { id: '9B795071-1EAF-492B-A84B-209DE77148BC' },
    Apostolides_John_B: { id: '02E56D4C-FFAD-4A44-A7B9-9927CB1B2787' },
    Appel_Jennifer_L: { id: '34FBE2FB-F14B-4919-BEE2-E9C03D83EEED' },
    Arakaki_Mihwi: { id: 'ED0581C9-B561-46D9-B173-399DD5347A0D' },
    Asamoah_Boateng_Jonas: { id: '97150CCD-1249-4129-962C-E8954C456C1E' },
    Asbridge_Dorothy_J: { id: '57BC10D0-755A-45C0-82A3-361B695E94F4' },
    Baker_Chelsea_C: { id: '02003CA1-57C9-4FA5-9645-88AC15224887' },
    Barger_Veronika: { id: '5D326F96-4D35-470C-9CB7-F74D2A33D4E9' },
    Barlow_Lucy_I: { id: '903DA3E2-47ED-4466-B9DF-CC39DBB7FA6E' },
    Barnette_Carlotta_A: { id: '743247FA-3794-433D-B93B-3B8F928D51CC' },
    Bassi_Diana_L: { id: '047645C4-7564-42A8-8DA9-66793AE11152' },
    Battershell_Moriah_R: { id: 'E5716473-08E1-4A5F-8801-E9134650F1A3' },
    Beatty_Matthew: { id: '0AD4E730-8F18-4E95-AEEA-2ED5C337C151' },
    Beckwith_Debra_L: { id: '3ED4A9A4-1C03-4B3A-AB2C-394FBAD20616' },
    Benson_Katherine_E: { id: 'AB752D13-733E-442E-BF28-4F0D007240E2' },
    Blake_Ashley_L: { id: '6DFFE869-54D1-4F06-AD75-67938B03D054' },
    Bland_James_W: { id: 'E2899865-11A1-4C45-A63B-25BFBE878157' },
    Bloomfield_niemi_Brent_A: { id: '91144B26-E94B-4458-81BE-760C041BA4B2' },
    Bonine_Leisha_A: { id: '2780E489-CB20-435C-95B3-0894791ED717' },
    Boyd_Melissa_M: { id: 'DCF96BA4-5742-4C95-8864-EA32C45CC7EA' },
    Brady_Krisula_M: { id: 'ACCE9F0D-435F-4BC4-A203-E560C925D5ED' },
    Brendible_Jacklyn_V: { id: '1FD1AA82-942A-40EE-95D4-F34305640AF6' },
    Bridges_Penny_A: { id: '6CE05384-AE14-42BC-AFD8-56668692CD4B' },
    Bridgman_Jonathan_I: { id: 'B516848B-086A-4D34-A880-8003A79A5772' },
    Bristow_Calen_J: { id: '3C47F3B2-3641-4CFD-AC80-E684F11B1A94' },
    Brokaw_David_C: { id: '5055B0DF-34AB-42AA-8AD4-07E7FB95293E' },
    Brown_Tim_D: { id: '76F28D37-BACE-4732-9EC7-613C0C168C53' },
    Bruer_vandeweert_Jennifer_E: { id: '7EDEECA4-5DD2-452A-9764-255A855A03E1' },
    Bustamante_Wendy_A: { id: 'C480CA37-6D58-4B52-8384-307ED220F777' },
    Cain_Brandon_M: { id: 'E348AC0E-CC2C-4EC4-B3FE-122982161F4E' },
    Calos_Brandon_N: { id: 'B78EA3D9-B3C7-4DA9-B9BF-204181F8C3FA' },
    Cambra_Christine_A: { id: '684B20C2-BAB0-4E22-BFE0-22F8CBB994C5' },
    Cambra_Jason_W: { id: '9644A788-B9C2-4D1F-B6DA-23A3589DBB75' },
    Capsel_William_M: { id: '71914428-3E74-4DBE-8924-1A9B0F87A9D0' },
    Carrell_Jason_D: { id: 'D271A345-ED7C-412A-BB26-27A41FE3399D' },
    Chambers_Roy: { id: 'D572BDB6-B1F9-4B6B-B889-24BF784E8ECB' },
    Chege_Mary_W: { id: 'E2146C04-9FBC-40FD-9845-93411A7D1AF9' },
    Class_Open_Bhs: { id: 'BBE3CBED-00AB-481F-BA8B-A0C8F5BD00FD' },
    Class_Open_Bhs_: { id: '8D6B56F6-1C45-4639-9BDC-ACEB6A8249BD' },
    Cooper_Heather_R: { id: '9323D011-7A64-407B-9C95-9394A0CE5822' },
    Cornia_Mallory_A: { id: 'A88C28D8-884B-46E0-B7C9-4B471B816F43' },
    Counselor_Test: { id: 'D0BE8C3F-08B4-48BA-AA0A-7C03472D4121' },
    Covell_Janeen_B: { id: 'B903D801-3CD3-459F-892E-86B8AAADC2A2' },
    Cox_Hollie_F: { id: '7B9AE4DE-699F-4749-816E-EA30EBD3529D' },
    Crow_cyr_Haili_L: { id: '313E705D-A466-4B89-9F26-B335CC5F17E7' },
    Dansereau_Katheryn_A: { id: '9C064163-370F-4D03-96A0-A57D0E06B8F7' },
    Darisme_Kolby: { id: '1F58B681-34C4-4B37-BD18-E6A59561ED54' },
    Davis_Sherry_L: { id: 'DD9C792A-84F5-4A77-AA27-9D489450B4B0' },
    Dawkins_Tracey_L: { id: '7425C650-A24B-4751-8F39-63463BEEF62E' },
    Dent_Christopher_C: { id: '8466D192-7E2D-4835-B2F4-F82C152E8862' },
    Donaldson_Jeffrey_R: { id: '085B78F7-0225-49EA-B600-EE1456D20586' },
    Doolittle_Alexandra_L: { id: 'FCFBD517-8B6F-4F39-B307-8FA787B91487' },
    Doyle_Suzanne_M: { id: 'A7ABDA74-2925-42EF-AC7C-6326DC6E4B20' },
    Drivas_Teresa: { id: '8C723135-4BBB-492D-A3A0-4679A277C88A' },
    Duane_Theresa_C: { id: '2C1B8695-AF63-4EDD-A7E6-F5EB5F7EE5B4' },
    Duke_Robert_B: { id: '272FB6F0-4ABA-43CD-AF15-E867D873AC82' },
    Eaton_Thomas_L: { id: 'EA481B86-3564-4812-838B-292CEB52042B' },
    Ehrlick_Sage: { id: '222DFA7B-DE1E-44E2-8DCD-E1F09F1A82CF' },
    Elliott_Patsy_L: { id: '2ACD2B43-231B-4B16-A419-E7DD8F84736A' },
    Estrada_Jennifer_B: { id: '5A278915-6DA9-45BF-967A-D3C6909CAE36' },
    Fernandez_Zesty_A: { id: '918E6D22-B9A4-433C-AABF-A9B89FF5B6EF' },
    Fia_Ruby_S: { id: 'FEC34F66-B080-4F34-B598-5AD62FA6528B' },
    Fjeld_Katrina_A: { id: '9E406B86-1EE1-4C29-A143-76EF8793B4C3' },
    Fleming_Patricia: { id: 'E58D1A62-5E7A-4F5D-98A1-8255222E36AC' },
    Forse_Lita_L: { id: '0F1BEED4-C6A0-4C0C-A75E-2980111A3E4E' },
    Forte_Demetrius_L: { id: 'F8AA9E95-0D5B-4B0D-9A81-262AC7DD9832' },
    Fowler_Ethan_T: { id: '11FF7A1C-7D63-4644-BAAE-D59851A2DC6A' },
    Fowler_Krystall: { id: 'EF0E762D-7A7D-4BBD-864B-4C6D6743E9FF' },
    Fowler_Raylene_K: { id: 'E3741ADD-A38D-4CF3-8628-80E31B902401' },
    Fox_Dawn_W: { id: '468C1E0A-CFA7-4279-B69E-EE1DA7E010FD' },
    Frady_Sadie_L: { id: '1C531504-DCF3-45C8-9C6A-D8871020CED1' },
    Frederick_Hasani: { id: 'FA9DFAA2-9D5E-45B9-B6E5-88EBA6B1F1EF' },
    Frederick_Kristina_M: { id: '5FEDD292-E101-4C7E-B4AC-E4578C9F1C6D' },
    Gallagher_Markelle_E: { id: '54DCF62C-F808-4186-AD5B-32DCDADE4F6A' },
    Gardner_Kenneth_A: { id: '6A3A1070-A936-4DC5-9DB3-9D0DF300406C' },
    Gibbs_Denise_R: { id: '05B18ACF-4FB0-4D48-A97B-5E8A295FE753' },
    Gillis_Christina_A: { id: '52633B2C-4B85-4D0C-A04C-BAF199FBAE4B' },
    Gladfelter_Irl_A: { id: '4CE7FB9A-1C6F-4174-9C50-9F32F056B707' },
    Greenland_Roy_F: { id: 'B166B6A9-11AA-44BD-B68E-1518401C5214' },
    Grimaldi_Marseille: { id: 'D719CA06-D9DE-41CE-A720-E85875F2B2B5' },
    Haegele_Dennis_S: { id: '11F13E4A-D3C2-44C2-B85E-E42D044C4A7D' },
    Hamilton_Michelle_Y: { id: '5ED1F075-B1E6-4012-9F25-F9BD96DE3CB7' },
    Harris_Brittney_V: { id: '2BF9E3C8-9635-4E8F-A670-9A607A90172E' },
    Hawes_Theresa_M: { id: 'C213A95E-A0AA-4068-8023-F4A6CFD379A7' },
    Hilsabeck_Erika_M: { id: '58FE4068-5B69-403B-9785-B26796E8958C' },
    Hochstein_Melissa_A: { id: '30573ADE-5244-47EC-A1E6-E384ABD3BDA9' },
    Hodges_Denise_L: { id: '561420AA-D874-468B-9456-D52910FE8633' },
    Hodges_Robin_L: { id: '4A50F7CC-C03A-4235-9A96-AED77A7C2082' },
    Hogan_Ralph_L: { id: 'AE7E6FBB-B8BD-4FCE-B805-0FDBB9CDBE73' },
    Howard_Loree_M: { id: '292C3235-37B1-4475-B807-708D0A336D0D' },
    Howard_Raenay_E: { id: '694918D4-5003-4FAF-8EF5-D73D69229B07' },
    Hubeek_Whitney_E: { id: '1B5BFD83-2919-4A21-85A0-CD82D6364AF2' },
    Hulse_Jennifer_R: { id: '4E122C8C-BE01-49FC-83BE-F54E2105AC82' },
    Hunt_Coral_Lee_S: { id: '91D74B1F-E4DC-46F1-B310-7D2FBF0FBE42' },
    Iddins_Mark_J: { id: '818785EB-41A3-441F-A1CF-3444C9EC66EF' },
    Ito_Megumi: { id: '87E25A49-8848-4168-B443-268B35535C85' },
    Iverson_Kenneth_B: { id: 'F0887088-6E68-4CB7-82A1-EFD647AA0DD4' },
    Janshen_Jocelyn_A: { id: '2727A0B8-CA71-42B9-943C-CFE77623EE7F' },
    Jin_Heather_A: { id: 'FA488816-194B-4EB1-8289-E644008DC7CB' },
    Johnson_Anthony_I: { id: '0F1BCF7B-6D14-40B4-B533-84CE2DD1EC03' },
    Jolly_Morgan_D: { id: 'D81A4ABA-8EAB-40D1-8DCA-AEA24D5DF935' },
    Jones_Marvia_C: { id: 'BC69C4D1-66E8-4E6D-BBF7-AD9B8A56B325' },
    Jones_Stephanie_J: { id: 'AB712207-5B06-41E9-B3CE-34DF44161E8F' },
    Kennedy_lindsay_Jordann_A: { id: '8D141673-B598-42A6-BD32-581179D11D6A' },
    Kintz_Kevin_A: { id: '6EDDF615-60D5-45AA-8B3F-A3D04DDF1533' },
    Knight_Cherrie_L: { id: 'ED5B67E9-0DB6-4493-B5FF-D3D0AC2B4D0D' },
    Knox_Caleb_M: { id: 'EA675775-8E99-489C-94E4-86228C4F1892' },
    Kubena_Nanette_M: { id: '6A89F25C-C5A8-4072-91F5-FD51BCD064F0' },
    Lantz_Daniel_R: { id: '736302BF-89B1-4FC3-BC31-ED8CFA8D4E6C' },
    Lininger_Matthew_A: { id: '53E2DE8D-5389-4B48-A8BD-54F91747D756' },
    Loiselle_Ryan_A: { id: '8C2BA073-F252-4166-9AA0-8BAA32010154' },
    Lordahl_Sandra_M: { id: 'EBD98843-B76C-42A2-BBB7-3EE0D27F4C5B' },
    Lowey_Michael_A: { id: '4BF702DB-AC83-473A-B4FE-614D7833AB8A' },
    Lowry_Tyson_R: { id: '12CFBCC9-8EEA-4808-A601-15A2FC14A00B' },
    Mamaril_Karen_R: { id: '6F05A884-48DB-4779-BE31-FDB729D8BFCC' },
    Martinez_Anthony_B: { id: '8B993CA0-E6E8-4FAF-88B2-2482DE156766' },
    Matthews_Tyler_M: { id: '2ECF16B4-C9CA-41C1-ACE7-AAE3CA5855AE' },
    Mccann_Clifford_L: { id: '09441DB3-3CF9-409B-A292-5592502AE241' },
    Mccann_Kimberly_A: { id: '02EA44F7-43DF-43C8-ABF2-69095370480A' },
    Mcmullen_Michael_L: { id: '79B5123B-82E3-4DF2-A20F-ABEDD6A0BDC4' },
    Melson_Kayla_G: { id: '3984DFAE-6BA2-4293-BD5B-8224D290047E' },
    Metcalf_Cody_D: { id: 'ECDC12AB-DD97-485F-B856-473EBD0AC8A9' },
    Miller_Janet: { id: '2A97C66B-DA43-4A15-AF73-D17FB971637C' },
    Misley_Philip_J: { id: 'ED394502-C892-444F-988E-528DD1D4655A' },
    Morford_Tressa_K: { id: 'E7E3184B-A6CD-4DC5-8DCF-E7EED29B1043' },
    Morrison_Jennifer_M: { id: '6C0E7AA5-FB41-46C7-A017-125B4590EF87' },
    Mounts_Donna_M: { id: '1D02B4F4-D504-4543-B063-B9D9A9E1C05B' },
    Nader_Heidi_M: { id: 'CF1C1349-CA28-4C8C-8102-57325076862F' },
    Nelson_Lance_E: { id: '66C3E5D6-5647-4139-9E80-9167D9B3D353' },
    Northington_Vera_A: { id: '7DAD4E68-6A68-4823-A933-C6864652D72F' },
    Odonnell_Brendan_R: { id: 'D8215B42-7E71-4527-96BA-19B5CABA8C9B' },
    Officeclerk_Test: { id: '416F3507-2ACC-4B26-8983-E98637C37D00' },
    Ohlinger_James_R: { id: '556E9392-526E-4D1A-BF50-0A60C8A8B682' },
    Olsen_Carolyn_E: { id: '4FAEBA9F-C818-4B1D-B633-00F39B87ADC6' },
    Parker_Jessica_A: { id: 'A84A6028-B7A1-4216-BA17-83FCC23E5CF4' },
    Parsons_Terri_L: { id: '31A89CCE-50F7-48D8-8FF8-2ABB66DF7187' },
    Partin_Mariah_F: { id: 'A4546D1E-8F43-439F-BB41-B35B17CCC07C' },
    Pelandini_Rebecca_M: { id: '1197C2BF-DC5E-432A-97C9-AAD0F12D9577' },
    Peterson_Gaylin_M: { id: '6A22E3AA-7D3A-418B-BA91-7951A9FE498F' },
    Pike_Stephanie_R: { id: 'FB630C19-B6B5-4206-BAAA-760A36CF2891' },
    Poljak_Jeff_L: { id: 'B75BE689-3365-49C4-BB7F-2892F8376E66' },
    Powers_Devon_K: { id: '8450FEAB-A4BA-4486-858A-9BA35A4245D7' },
    Price_Leslie_S: { id: 'FEBDC54D-8BF6-4385-8021-F36A9D582A62' },
    Racus_Britni_E: { id: '8EF962D6-ACFE-434F-BFCA-DB9B9D52D3AA' },
    Rath_Patricia_E: { id: '87361F26-64B4-4245-BD95-A20E8495F86B' },
    Reisch_Rebecca_D: { id: '67BF212C-EB81-4FE3-AC0D-03AB4AD5F8F4' },
    Rexus_Daniel_R: { id: 'EB696A7C-FD7F-4A05-B60C-217D04FDD7FF' },
    Ridgway_Thomas_G: { id: 'D6880979-2D55-48BB-AEC1-85AE6DA526FE' },
    Ries_Lindsay_A: { id: 'F4C96C50-2CAC-4A9A-8180-C85F0DA90187' },
    Riggle_Brian: { id: 'D1A13D83-CBBF-4374-9D73-0470179DC7BF' },
    Riley_Deanna: { id: 'A4EADC09-21D5-4358-A96A-6DDC3CBF520A' },
    Riston_Dale_M: { id: '8C43045F-6DBD-4813-83F4-929FB1D1A001' },
    Roberts_Lori_C: { id: '548EFBE2-9BCF-4B7E-8B11-BD7157BA220C' },
    Rochefort_Lori_A: { id: '0EF4B9C8-5526-493D-B40E-78593DD0D75C' },
    Rodriguez_Christy_L: { id: 'D1FAA3EB-2676-400F-991F-8ADFAB1C83B7' },
    Rudenko_Oksana_S: { id: '371720D0-509F-4436-86AC-6632A0C4973C' },
    Sacks_Michael_J: { id: '230AACC0-BE2D-45D2-8A9C-7E99565CDAE8' },
    Saffle_Teal_H: { id: 'AB98701E-A3DE-47A9-99DB-5AAC7397EB11' },
    Salas_Eddie: { id: '76ED121D-FD05-493A-91C4-02EEFD1867E1' },
    Samonte_Maria_R: { id: 'B48A8FDB-F4BB-4084-8DAC-94B328F5D075' },
    Sampson_Allison_M: { id: 'B19AF45D-7C9B-4F77-A195-6F3C31FB705F' },
    Sanders_Jr_Terry_S: { id: '3D4A22C9-EA8C-4213-8C6A-6815E6E65AE2' },
    Sauer_Kyle_D: { id: 'F5C93D23-A66E-4BBF-8D00-9863CE0822C0' },
    Schad_Amanda_M: { id: 'FD75ACC5-EA62-47B7-8374-A1F59B1B960D' },
    Scheirer_Nep_K: { id: 'CA1A7913-C0A5-4C92-A491-3F9CE9242DD4' },
    Schreiber_Nathan_A: { id: '3E7413CA-5771-4987-9E1C-91F97715C589' },
    Schultz_wetherington_Katherine_A: { id: '05CB9140-0555-459A-8EF4-906E4CC765FA' },
    Schwoch_Kevin_R: { id: '554D6D51-BA62-414B-AE85-4359EECBEBAD' },
    Sheline_Barbara: { id: 'B133B6B0-7949-41E7-9685-E54DC4322CFF' },
    Shelley_Bonnie_R: { id: '51D03379-BBB9-473D-ADC1-91176EA278D5' },
    Sherve_Patricia_S: { id: '0A4174AB-D5C2-4BEE-BDD6-B6FBF2771777' },
    Shinn_Shannon_L: { id: 'B5B90412-54A3-4AB4-A181-F5355C519F79' },
    Shinnick_Nelson_N: { id: '5CBA1D97-AB6E-4FFD-B8AE-71D408088C02' },
    Shoot_Andrew_L: { id: '31132696-3038-4611-9A5D-4F07D3D57F0A' },
    Simatic_Trisha: { id: 'B1ECD5E9-8D4D-4611-A3F4-CDD79938E858' },
    Simmons_Nancy_M: { id: '8F7B35B6-D2E9-4507-8D3A-CE119508E98A' },
    Sloan_Heather_D: { id: 'A932EFA7-4F25-41EF-A799-498C9C875127' },
    Smith_Paul_J: { id: 'EDC2D54F-4F19-4E73-BB93-F2D581CDF959' },
    Snedigar_Janell_A: { id: '3A021C70-1EBB-4EC3-A30F-1D3BCBC75B55' },
    Snow_Deborah_A: { id: 'E0322F38-B08D-4A24-8ECD-C5C51CBB91BF' },
    Sokimi_Alijah_S: { id: '2A2B543A-4CB9-4989-85E6-5548DB61F480' },
    Soriero_Sabrina_L: { id: 'BE947D94-A04C-425F-B91F-5AA4402F312F' },
    Southworth_Gregory_W: { id: 'CBDFA846-B3CB-45C5-BB36-C870B5AC4099' },
    Stern_Pamela_S: { id: '8D601451-1F29-44C4-9F33-B40659143F33' },
    Stickney_Christopher_L: { id: 'A8AD9309-73C4-4388-B7AC-143365A4580C' },
    Stoyles_Robin_W: { id: '9026DCA6-3E08-4857-8C46-808BA53CC2AC' },
    Stumpf_John_R: { id: 'CDE89AD0-1D63-4DB7-8C89-A66F1C5C41E2' },
    Talen_Michael_H: { id: 'AD4CA338-FDFF-47E8-8378-306F91D7CC6C' },
    Taylor_Claire_V: { id: 'D628E698-735A-4FA3-903F-CC04C4FF1487' },
    Terzigni_Lauren_E: { id: 'C58EB20D-5BD5-44F1-864A-AC4BA0F7EE2B' },
    Thiel_Janie_L: { id: '01462BC2-2B01-47E9-AEBF-23AF3F47D1D1' },
    Thomas_Dana_M: { id: '2F8E35BC-EF62-47FB-8AB4-C31F13F9E34A' },
    Thorn_Danielle_E: { id: 'F315657A-F3F1-459E-ABE8-003D4D3ECF81' },
    Tkach_Stephen_J: { id: '0D9677FA-FC67-46A0-8884-2F9A5DD1B78B' },
    Utley_Gloria: { id: '9B936254-5767-4C0F-8852-CBFADF9B5F7E' },
    Vallier_Heather_M: { id: '10B967EC-7856-481F-A582-B084362DE8E0' },
    Villarreal_Victor_D: { id: '3C82CF8B-DBE7-45E0-BF36-31D7FCB804B0' },
    Waters_Jennifer_M: { id: '6797DCD0-7D92-49DF-8A1F-A88CF96CF74F' },
    Watson_Hayley_J: { id: 'D7909253-BF85-4F26-91AF-4D19354B9CB4' },
    Welborn_Scott_T: { id: 'D0D2392F-7F50-4455-91D5-10100D8DE67D' },
    Wenning_Ana_L: { id: '04AA2A74-C696-4658-8433-3523034B0927' },
    Wetherington_John_M: { id: 'E597CBAA-D3C7-4C74-B0B3-9DAAAE85CCF2' },
    Whisnant_Michelle_A: { id: 'A724389F-016C-4EBD-A023-B62D5A56AA94' },
    Whitehead_Ryan_D: { id: '961F3156-7FD9-40E9-A296-651C27259733' },
    Wiggins_Malissa_J: { id: 'D340A2CC-B19F-4689-A7A0-B74485EB8B80' },
    Wilbur_Brooklyn_P: { id: '0704D44C-CADE-4EE4-B996-4C8D2B1F3391' },
    Wilson_Anne_M: { id: '49512926-C5E3-42C7-90FA-AEE628D72717' },
    Wilson_Dominique_A: { id: 'A5695EAE-8607-4F1D-AEED-7AF1EFA73EA7' },
    Wilson_Zuleica_E: { id: '396004E3-F3B8-46B3-9C36-FB8C82ECDDD3' },
    Winders_David_C: { id: '1018B211-5326-4216-8458-50F086C233D6' },
    Wolff_Laural_A: { id: '34EDFECC-DF44-4C76-B62F-1A2912C623F6' },
    Wood_Julana_M: { id: 'EBE2A4EF-690D-4A4D-B0FC-6DDD9941FF65' },
    Wren_Keith_E: { id: '369E22E3-265F-46FC-8E3D-B71A7B7EA6B4' },
    Yahne_Jenina_M: { id: '96A7F26E-E17E-4721-9F56-DFC4E13EA4C6' },
    Yant_Kim_Y: { id: 'FD4D5282-C675-4044-8EF4-462D553EA5FA' },
    Zinkov_Oksana_N: { id: '48CAA8D4-9E57-493B-8FFD-6315E26E6D7A' },
    Zornes_Kathryn_L: { id: 'F5A6F64D-C3D6-4F06-B4B2-DDA609D9ECD0' },
    Zz_Class_Open_Bhs: { id: 'B848ADE7-D30F-47F5-8505-157DA0AE71F2' },
};

export type Teachers = typeof teachers;
